var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.accountPage,
        ((_obj = {}),
        (_obj[_vm.$style.accountPageMobile] = _vm.isMobilePlatform),
        _obj)
      ]
    },
    [
      _c(
        "a",
        { class: _vm.$style.logoLink, attrs: { href: "#" } },
        [_c("Logo")],
        1
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style.accountTitle }, [
        _c("h5", [_vm._v("My Account")])
      ]),
      _vm._v(" "),
      _vm.user
        ? _c(
            "div",
            { class: _vm.$style.mainAccountInfo },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        md10: "",
                        lg6: "",
                        "offset-xs0": "",
                        "offset-md1": "",
                        "offset-lg3": ""
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              class: _vm.$style.appGrid,
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.$style.accountInfoField },
                                [
                                  _c(
                                    "h6",
                                    { class: _vm.$style.acoountInfoTitle },
                                    [_vm._v("First Name*")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { class: _vm.$style.accountInfoValue },
                                    [_vm._v(_vm._s(_vm.user.firstName))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              class: _vm.$style.appGrid,
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.$style.accountInfoField },
                                [
                                  _c(
                                    "h6",
                                    { class: _vm.$style.acoountInfoTitle },
                                    [_vm._v("Last Name*")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { class: _vm.$style.accountInfoValue },
                                    [_vm._v(_vm._s(_vm.user.lastName))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              class: _vm.$style.appGrid,
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.$style.accountInfoField },
                                [
                                  _c(
                                    "h6",
                                    { class: _vm.$style.acoountInfoTitle },
                                    [_vm._v("Email*")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { class: _vm.$style.accountInfoValue },
                                    [_vm._v(_vm._s(_vm.user.email))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              class: _vm.$style.appGrid,
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.$style.accountInfoField },
                                [
                                  _c(
                                    "h6",
                                    { class: _vm.$style.acoountInfoTitle },
                                    [_vm._v("Phone*")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { class: _vm.$style.accountInfoValue },
                                    [_vm._v(_vm._s(_vm.user.phone))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              class: _vm.$style.appGrid,
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.$style.accountInfoField },
                                [
                                  _c(
                                    "h6",
                                    { class: _vm.$style.acoountInfoTitle },
                                    [_vm._v("Birthday (optional)")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { class: _vm.$style.accountInfoValue },
                                    [_vm._v(_vm._s(_vm.user.birthday))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-flex", {
                            class: _vm.$style.appGrid,
                            attrs: { xs12: "", md6: "" }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              class: _vm.$style.appGrid,
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.$style.accountInfoField },
                                [
                                  _c(
                                    "h6",
                                    { class: _vm.$style.acoountInfoTitle },
                                    [
                                      _vm._v(
                                        "\n                Mailing Address (optional)\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { class: _vm.$style.accountInfoValue },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.fullAddress) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              false
                ? _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            "offset-md1": "",
                            "offset-lg3": "",
                            md10: "",
                            lg6: ""
                          }
                        },
                        [
                          _c("h6", { class: _vm.$style.preferencesTitle }, [
                            _vm._v("Preferences (optional)")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  class: _vm.$style.appGrid,
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.$style.accountInfoField },
                                    [
                                      _c(
                                        "h6",
                                        { class: _vm.$style.acoountInfoTitle },
                                        [_vm._v("Preference Question #1")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { class: _vm.$style.accountInfoValue },
                                        [_vm._v("Tustin")]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  class: _vm.$style.appGrid,
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.$style.accountInfoField },
                                    [
                                      _c(
                                        "h6",
                                        { class: _vm.$style.acoountInfoTitle },
                                        [_vm._v("Preference Question #2")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { class: _vm.$style.accountInfoValue },
                                        [
                                          _vm._v(
                                            "\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                Nam ultrices nibh lacus, in dictum quam volutpat eget.\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  class: _vm.$style.appGrid,
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.$style.accountInfoField },
                                    [
                                      _c(
                                        "h6",
                                        { class: _vm.$style.acoountInfoTitle },
                                        [_vm._v("Preference Question #3")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { class: _vm.$style.accountInfoValue },
                                        [
                                          _vm._v(
                                            "\n                Lorem ipsum dolor sit amet\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  class: _vm.$style.appGrid,
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.$style.accountInfoField },
                                    [
                                      _c(
                                        "h6",
                                        { class: _vm.$style.acoountInfoTitle },
                                        [_vm._v("Preference Question #4")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { class: _vm.$style.accountInfoValue },
                                        [
                                          _vm._v(
                                            "\n                Nam ultrices nibh lacus, in dictum quam volutpat eget.\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobilePlatform
                ? _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "BaseButton",
                            {
                              class: _vm.$style.accountEditBtn,
                              attrs: { "button-style": "Main" },
                              on: { click: _vm.openEditAccount }
                            },
                            [_vm._v("\n          Edit Account\n        ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { "justify-center": "" } },
                [_c("RemoveAccountButton")],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserAccount.vue?vue&type=template&id=d0002e3c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 